<!--
 * @Description: 
 * @Version: 2.0
 * @Autor: zh
 * @Date: 2021-11-19 10:09:14
 * @LastEditors: zh
 * @LastEditTime: 2022-02-17 14:11:19
-->
<template>
  <div class="main">
    <div class="center-box">
      <img src="../../assets/images/stafflogo.svg">
      <div class="title">{{$t('staffLogin.title')}}</div>
      <div class="bottom-box">
        <div class="item" v-for="(item,index) in $t('staffLogin.urls')" :key="index">
          <div class="margin-b title-color">{{item.title}}</div>
          <div class="margin-b showhand" v-for="(ele,sonIndex) in item.contents" :key="sonIndex" @click="goTo(ele.url)">{{ele.name}}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default({
  data() {
    return {}
  },
  methods: {
    goTo(path) {
      window.open(path,'_blank')
    }
  }
})
</script>

<style scoped>
  .main{
    height: 100vh;
    width:100%;
    background: url('../../assets/images/staffLoginbg.jpg');
    background-size:cover;
    background-position: center center;
    background-repeat: no-repeat;
    font-family: 'Lato';
  }
  .center-box{
    margin: 0 auto;
    text-align: center;
    position: relative;
    top:50%;
    transform:translateY(-50%);
  }
  .center-box img{
    width: 18%;
  }
  .title{
    font-size: 50px;
    font-weight: 300;
    color: #ffffff;
    padding: 50px 0;
  }
  .bottom-box{
    margin: 0 auto;
    width: 60%;
    display: flex;
    justify-content: space-between;
  }
  .item{
    padding-left: 40px;
    color: #ED6D00;
    width: 25%;
    line-height: 27px;
    text-align: left;
  }
  .title-color{
    color: #ffffff;
  }
  .margin-b{
    margin-bottom: 20px;
  }
  .showhand{
    cursor: pointer;
  }
  @media screen and (max-width: 1680px) {
    .bottom-box{
      width: 70%;
    }
  }
  @media screen and (max-width: 1399px) {
    .title{
      font-size: 40px;
      padding: 30px
    }
    .margin-b{
      margin-bottom: 15px;
    }
    .item{
      font-size: 18px;
    }
    .bottom-box{
      width: 70%;
    }
  }
  @media screen and (max-width:768px) {
      .center-box img{
        width: 28%;
      }
      .center-box{
        padding-top: 100px;
      }
      .bottom-box{
        width: 95%;
      }
  }
</style>


// WEBPACK FOOTER //
// src/pages/staffLogin/staffLogin.vue